import { Star } from '@phosphor-icons/react';

export default Star;
